const IMG = "/images/games";

const playersOf = (slug) => {
  let h = 0;
  for (const c of slug) h = (h * 31 + c.charCodeAt(0)) % 100000;
  const n = 120 + (h % 880) + (h % 10) / 10;
  return `${n.toFixed(1)}K`;
};

const g = (name, slug, bonus, logo, extra = {}) => ({
  name,
  slug,
  bonus,
  players: playersOf(slug),
  minWithdraw: 100,
  logo: logo.startsWith("http") ? logo : `${IMG}/${logo}`,
  ...extra,
});

// Main list (Old Games) - same order as yonogamesplanet.com homepage
export const allGames = [
  g("All Yono Games", "all-yono-games", 1000, "all-yono-games-logo-w128.webp", { warning: true }),
  g("Rummy Zip", "rummy-zip", 88, "rummy-zip-logo-w128.webp"),
  g("Jeet Spin", "jeet-spin", 500, "jeet-spin-logo-w128.webp"),
  g("Max Rummy", "max-rummy", 99, "max-rummy-logo-w128.webp"),
  g("Win Rummy", "win-rummy", 147, "win-rummy-logo-w128.webp"),
  g("Gold Rummy", "gold-rummy", 451, "gold-rummy-logo-w128.webp"),
  g("Money Rummy", "money-rummy", 100, "money-rummy-logo-w128.webp"),
  g("Ok Rummy", "ok-rummy", 311, "ok-rummy-logo-w128.webp"),
  g("IND Rummy", "ind-rummy", 101, "ibb-N2fpcLk1-w128.webp"),
  g("Rummy Ludo", "rummy-ludo", 275, "rummy-ludo-logo-w128.webp"),
  g("Game Rummy", "game-rummy", 148, "ibb-fYsjQSG5-w128.webp"),
  g("Rumble Rummy", "rumble-rummy", 431, "ibb-LXrFTcDw-w128.webp"),
  g("Top Rummy", "top-rummy", 444, "top-rummy-logo-w128.webp"),
  g("Spin 777", "spin-777", 305, "spin-777-logo-w128.webp"),
  g("Rani Slots", "rani-slots", 335, "ibb-N2Tfm5My-w128.webp"),
  g("Jaiho 777", "jaiho-777", 255, "jaiho-777-logo-w128.webp"),
  g("YN 777", "yn-777", 381, "ibb-ZzC0tH5p-w128.webp"),
  g("Spin 101", "spin-101", 341, "spin-101-logo-w128.webp"),
  g("INR Slots", "inr-slots", 77, "ibb-5Zfp5mV-w128.webp"),
  g("Bingo 101", "bingo-101", 291, "bingo-101-logo-w128.webp"),
  g("IND Club", "ind-club", 151, "ind-club-logo-w128.webp"),
  g("Joy Rummy", "joy-rummy", 115, "ibb-7tL5ghGJ-w128.webp"),
  g("Yono Slots", "yono-slots", 68, "yono-slots-logo-w128.webp"),
  g("Spin Crush", "spin-crush", 81, "spin-crush-logo-w128.webp"),
  g("Rummy 888", "rummy-888", 51, "rummy-888-logo-w128.webp"),
  g("Diwa 777", "diwa-777", 545, "ibb-cXTL1gK8-w128.webp"),
  g("Diwa Slots", "diwa-slots", 98, "diwa-slots-logo-w128.webp"),
  g("Rummy 77", "rummy-77", 245, "rummy-77-logo-w128.webp"),
  g("777 Game", "777-game", 105, "ibb-mVfjyJYc-w128.webp"),
  g("Jaiho Slots", "jaiho-slots", 175, "jaiho-slots-logo-w128.webp"),
  g("Hindi 777", "hindi-777", 345, "hindi-777-logo-w128.webp"),
  g("Ever 777", "ever-777", 125, "ibb-5hnTzTHQ-w128.webp"),
  g("Boss Rummy", "boss-rummy", 295, "boss-rummy-logo-w128.webp"),
  g("Yes Spin", "yes-spin", 461, "yes-spin-logo-w128.webp"),
  g("Maha Games", "maha-games", 277, "maha-games-logo-w128.webp"),
  g("Love Rummy", "love-rummy", 265, "love-rummy-logo-w128.webp"),
  g("Share Slots", "share-slots", 281, "share-slots-logo-w128.webp"),
  g("All Yono Apps", "all-yono-apps", 550, "all-yono-apps-logo-w128.webp"),
  g("Spin Winner", "spin-winner", 215, "spin-winner-logo-w128.webp"),
  g("Gogo Rummy", "gogo-rummy", 301, "gogo-rummy-logo-w128.webp"),
  g("Remi 101", "remi-101", 299, "remi-101-logo-w128.webp"),
  g("Hi Rummy", "hi-rummy", 168, "hi-rummy-logo-w128.webp"),
  g("Jaiho Rummy", "jaiho-rummy", 108, "jaiho-rummy-logo-w128.webp"),
  g("Jaiho Win", "jaiho-win", 55, "jaiho-win-logo-w128.webp"),
  g("Yono Arcade", "yono-arcade", 531, "yono-arcade-logo-w128.webp"),
  g("Jaiho Spin", "jaiho-spin", 231, "jaiho-spin-logo-w128.webp"),
  g("Rummy 91", "rummy-91", 471, "rummy-91-logo-w128.webp"),
  g("INR Rummy", "inr-rummy", 371, "inr-rummy-logo-w128.webp"),
  g("Slots Spin", "slots-spin", 399, "slots-spin-logo-w128.webp"),
  g("Jaiho Arcade", "jaiho-arcade", 499, "jaiho-arcade-logo-w128.webp"),
  g("Yono Vip", "yono-vip", 71, "yono-vip-logo-w128.webp"),
  g("567 Slots", "567-slots", 225, "567-slots-logo-w128.webp"),
  g("Slots Winner", "slots-winner", 181, "slots-winner-logo-w128.webp"),
  g("MKM Bet", "mkm-bet", 235, "mkm-bet-logo-w128.webp"),
  g("All Rummy Apps", "all-rummy-apps", 550, "all-rummy-apps-logo-w128.webp"),
  g("IND Slots", "ind-slots", 49, "ind-slots-logo-w128.webp"),
  g("Spin Lucky", "spin-lucky", 500, "spin-lucky-logo-w128.webp"),
  g("Club Inr", "club-inr", 201, "club-inr-logo-w128.webp"),
  g("Spin Gold", "spin-gold", 158, "spin-gold-logo-w128.webp"),
  g("MDM Bet", "mdm-bet", 365, "mdm-bet-logo-w128.webp"),
  g("789 Jackpots", "789-jackpots", 351, "789-jackpots-logo-w128.webp"),
  g("EN 365", "en-365", 188, "en-365-logo-w128.webp"),
  g("IND Bingo", "ind-bingo", 135, "ind-bingo-logo-w128.webp"),
  g("My 777", "my-777", 155, "my-777-logo-w128.webp"),
  g("101Z App", "101z-app", 131, "101z-app-logo-w128.webp"),
  g("Rummy 365", "rummy-365", 99, "rummy-365-logo-w128.webp"),
  g("Yono 777", "yono-777", 521, "yono-777-logo-w128.webp"),
  g("Bet 213 Slots", "bet-213-slots", 355, "bet-213-slots-logo-w128.webp"),
  g("MBM Bet", "mbm-bet", 128, "ibb-TqtKD7fn-w128.webp"),
  g("Yono Rummy", "yono-rummy", 271, "yono-rummy-logo-w128.webp"),
  g("Yono Games", "yono-games", 61, "yono-games-logo-w128.webp"),
  g("ABC Rummy", "abc-rummy", 95, "abc-rummy-logo-w128.webp"),
  g("Neta Vip", "neta-vip", 491, "neta-vip-logo-w128.webp"),
  g("Saga Slots", "saga-slots", 91, "saga-slots-logo-w128.webp"),
  g("Good Slots", "good-slots", 208, "ibb-JbN7t2H-w128.webp"),
  g("Yono All Games", "yono-all-games", 550, "ibb-ycYh7XwD-w128.webp"),
  g("Yono 808 Slots", "yono-808-slots", 78, "ibb-0yQRwf1N-w128.webp"),
  g("Yoho Slots", "yoho-slots", 401, "ibb-GvxZkvx3-w128.webp"),
  g("YN Rummy", "yn-rummy", 161, "ibb-bgzSNyTr-w128.webp"),
  g("Rummy 51", "rummy-51", 238, "ibb-KxGyFjcn-w128.webp"),
  g("MQM Bet", "mqm-bet", 248, "ibb-5gDkqm5H-w128.webp"),
  g("New Yono App", "new-yono-app", 138, "ibb-v6XMk6Z2-w128.webp"),
];

// New Games list - same order as yonogamesplanet.com/new-games
export const newGames = [
  g("New Yono Games", "new-yono-games", 108, "ibb-WpxMpjNs-w128.webp", { warning: true }),
  g("Money Rummy", "money-rummy", 100, "money-rummy-logo-w128.webp"),
  g("Gold Rummy", "gold-rummy", 451, "gold-rummy-logo-w128.webp"),
  g("Win Rummy", "win-rummy", 147, "win-rummy-logo-w128.webp"),
  g("Max Rummy", "max-rummy", 99, "max-rummy-logo-w128.webp"),
  g("Jeet Spin", "jeet-spin", 500, "jeet-spin-logo-w128.webp"),
  g("Rummy Zip", "rummy-zip", 88, "rummy-zip-logo-w128.webp"),
  g("Diwa 777", "diwa-777", 545, "ibb-cXTL1gK8-w128.webp"),
  g("Rani Slots", "rani-slots", 335, "ibb-N2Tfm5My-w128.webp"),
  g("Goa Spin", "goa-spin", 111, "ibb-mCH1sx4w-w128.webp"),
  g("Rumble Rummy", "rumble-rummy", 431, "ibb-LXrFTcDw-w128.webp"),
  g("Joy Rummy", "joy-rummy", 115, "joy-rummy-logo-w128.webp"),
  g("INR Rummy", "inr-rummy", 371, "inr-rummy-logo-w128.webp"),
  g("Rummy Sweety", "rummy-sweety", 285, "rummy-sweety-logo-w128.webp"),
  g("Boss Rummy", "boss-rummy", 295, "boss-rummy-logo-w128.webp"),
  g("Rummy 888", "rummy-888", 51, "rummy-888-logo-w128.webp"),
  g("Rummy 77", "rummy-77", 245, "rummy-77-logo-w128.webp"),
  g("777 Game", "777-game", 105, "ibb-mVfjyJYc-w128.webp"),
  g("Hindi 777", "hindi-777", 345, "hindi-777-logo-w128.webp"),
  g("Club Inr", "club-inr", 201, "club-inr-logo-w128.webp"),
  g("Ok Rummy", "ok-rummy", 311, "ok-rummy-logo-w128.webp"),
  g("Game Rummy", "game-rummy", 148, "ibb-fYsjQSG5-w128.webp"),
  g("Yes Spin", "yes-spin", 461, "yes-spin-logo-w128.webp"),
  g("Maha Games", "maha-games", 277, "maha-games-logo-w128.webp"),
  g("Love Rummy", "love-rummy", 265, "love-rummy-logo-w128.webp"),
  g("Share Slots", "share-slots", 281, "share-slots-logo-w128.webp"),
  g("Hi Rummy", "hi-rummy", 168, "hi-rummy-logo-w128.webp"),
  g("Jaiho Win", "jaiho-win", 55, "jaiho-win-logo-w128.webp"),
  g("Slots Spin", "slots-spin", 399, "slots-spin-logo-w128.webp"),
  g("ABC Rummy", "abc-rummy", 95, "abc-rummy-logo-w128.webp"),
  g("Neta Vip", "neta-vip", 491, "neta-vip-logo-w128.webp"),
  g("Saga Slots", "saga-slots", 91, "saga-slots-logo-w128.webp"),
  g("Jaiho 777", "jaiho-777", 255, "jaiho-777-logo-w128.webp"),
  g("Top Rummy", "top-rummy", 444, "top-rummy-logo-w128.webp"),
  g("Yono Play", "yono-play", 331, "ibb-Kc8qxXSn-w128.webp"),
  g("Yono Agent", "yono-agent", 185, "ibb-4RyW74d5-w128.webp"),
  g("UU Rummy", "uu-rummy", 85, "ibb-zWBW1zfT-w128.webp"),
  g("Spin Yes", "spin-yes", 221, "ibb-pjy3M9n4-w128.webp"),
  g("Jaiho 91", "jaiho-91", 501, "ibb-jPb8rCkz-w128.webp"),
  g("Jaiho Bet", "jaiho-bet", 251, "ibb-PZ5Pn3Zz-w128.webp"),
];

const gameMap = {};
[...allGames, ...newGames].forEach((game) => {
  if (!gameMap[game.slug]) gameMap[game.slug] = game;
});

export const getGameBySlug = (slug) => gameMap[slug] || null;

// Deterministic pseudo-random detail data per game (mocked)
export const getGameDetail = (game) => {
  let hash = 0;
  for (let i = 0; i < game.slug.length; i++) hash = (hash * 31 + game.slug.charCodeAt(i)) % 997;
  const rating = (4.1 + (hash % 8) / 10).toFixed(1);
  const sizeMin = 45 + (hash % 15);
  const sizeMax = sizeMin + 6 + (hash % 5);
  const downloads = ["50K+", "100K+", "500K+", "1M+"][hash % 4];
  const n = game.name;
  const b = game.bonus;
  const w = game.minWithdraw;
  const kind = /rummy/i.test(n) ? "rummy" : /slot|spin|777|jackpot/i.test(n) ? "slots" : "mixed";
  const lobby = { rummy: "rummy tables first, with slots and Teen Patti on the side", slots: "slot reels and spin games first, with a few card tables alongside", mixed: "a mixed lobby of rummy, slots, Teen Patti and quick rounds" }[kind];
  const glance = [
    `${n} is a ${kind === "rummy" ? "rummy-first" : kind === "slots" ? "slots-first" : "multi-game"} Yono app with ${lobby}. You sign in with a mobile number, get ₹${b} as bonus balance, and can cash out from ₹${w} to UPI or bank.`,
    `Think of ${n} as a compact casino lobby on your phone: ${lobby}. The ₹${b} welcome credit is for play, withdrawals open at ₹${w}, and the APK weighs around ${sizeMin} MB.`,
    `${n} packs ${lobby} into one wallet. New accounts receive ₹${b}, payouts begin at ₹${w}, and the app has crossed ${downloads} installs on our tracker.`,
    `At its core ${n} offers ${lobby}. ${n} signup takes an OTP, its ₹${b} bonus lands in a separate balance, and a ₹${w} withdrawal is enough to test the payout side.`,
  ][hash % 4];
  const safety = [
    `Share your OTP with nobody - ${n} support will never ask for it - and deposit only through the ${n} in-app payment screen, saving the UTR until the balance updates.`,
    `Install ${n} only from the button on this page, not from forwarded chat files, keep your UPI PIN private, and treat any ${n} "unlock your withdrawal" fee as a scam.`,
    `Use a bank account or UPI ID in your own name on ${n}, since third-party accounts get payouts held; set a daily ${n} limit before you open the app and log out on shared phones.`,
    `${n} is a real-money app, so protect your login like a bank app. Never reuse a ${n} OTP, avoid public Wi-Fi for ${n} deposits, and make a small first withdrawal before adding more.`,
  ][(hash + 1) % 4];
  const verdict = [
    `${n} is worth trying if you like ${kind === "slots" ? "quick spins and jackpot rounds" : kind === "rummy" ? "13-card rummy against real players" : "switching between card games and slots"}. Its ₹${b} bonus is decent and the ₹${w} payout floor is low; skip ${n} if you want Play Store-only apps.`,
    `${n} suits players who want ${lobby} without juggling several apps; try ${n} with a small deposit and, if your ₹${w} test withdrawal reaches you, scale up slowly.`,
    `${n} is worth a look for the ₹${b} start and the low ₹${w} cash-out, less so if you dislike APK installs - treat the ${n} bonus as practice money, not profit.`,
    `${n} is a fair pick among Yono apps - a steady lobby, OTP login and ${downloads} installs - just budget first and keep ${n} sessions short.`,
  ][(hash + 2) % 4];
  const downloadIntro = [
    `The ${n} app comes as an APK file, and setting it up takes a couple of minutes:`,
    `${n} is not on Google Play, so you install it as an APK. Here is the short route:`,
    `Getting ${n} on your phone is a two-minute job once you allow browser installs:`,
    `Follow these steps to install ${n} and claim the bonus:`,
  ][(hash + 3) % 4];
  const reqNote = [
    `With 60+ games on board, ${n} fetches extra game files as you open new tables, so keep some space free beyond the 300 MB minimum.`,
    `${n} runs fine on budget Android phones; a stable 4G connection matters more than RAM for smooth tables.`,
    `Older phones on Android 5 can run ${n}, but slot animations are smoother on Android 8 or newer.`,
    `Clear the ${n} cache from time to time - downloaded game assets can grow past 500 MB over a few weeks.`,
  ][(hash + 1) % 4];
  const c = game.content || {};
  const clean = Object.fromEntries(Object.entries(c).filter(([, v]) => v !== "" && v !== null && v !== undefined && !(Array.isArray(v) && v.length === 0)));
  return {
    ...{
    rating,
    size: `${sizeMin}-${sizeMax}`,
    downloads,
    glance,
    safety,
    verdict,
    downloadIntro,
    reqNote,
    requirements: [
      ["Android version", ["5.0 or newer", "5.1 (Lollipop) or newer", "6.0 or newer", "5.0+ (Android 8 recommended)"][hash % 4]],
      ["RAM", ["1 GB minimum", "1.5 GB recommended", "2 GB for smooth animations", "1 GB (2 GB recommended)"][(hash + 1) % 4]],
      ["Free storage", `${sizeMax * 4 + (hash % 37) * 5} MB`],
      ["Internet", ["Wi-Fi or 4G/5G", "Stable 4G or Wi-Fi", "3G works, 4G recommended", "Any mobile data or Wi-Fi"][(hash + 3) % 4]],
      ["Screen size", ["4.5 inches or larger", "5 inches recommended", "4.7 inches or larger", "Any phone or tablet screen"][hash % 4]],
      ["APK size", `${sizeMin}-${sizeMax} MB`],
    ],
    features: [
      [
        `${n} welcomes new users with ₹${b} signup bonus, one of the exciting offers among Yono apps.`,
        `A ₹${b} welcome credit lands in your ${n} wallet the moment your OTP is verified.`,
        `${n} hands every new player ₹${b} to try the lobby before any deposit.`,
        `Join ${n} with a mobile number and start with ₹${b} in bonus balance.`,
      ][hash % 4],
      [
        `${n} withdrawals start at just ₹${w} and go straight to your bank account or UPI.`,
        `Cash out from ₹${w} to UPI; most ${n} payouts clear within a few hours.`,
        `A low ₹${w} payout floor makes ${n} easy to test with a small deposit.`,
        `${n} pays by bank transfer or UPI from ₹${w}, with no paperwork beyond KYC.`,
      ][(hash + 1) % 4],
      {
        rummy: `Points, Pool and Deals rummy tables plus Teen Patti on the side in ${n}.`,
        slots: `${n} leans on slot reels, spin wheels and jackpot rounds with quick table games as extras.`,
        mixed: `Slots, rummy, Teen Patti and quick table games sit together in the ${n} lobby.`,
      }[kind],
      [
        `24x7 in-app support chat and daily check-in rewards inside ${n}.`,
        `${n} runs weekly bonus cards, a gullak saver and a referral link for extra rewards.`,
        `VIP levels in ${n} add rebates and cashback as you play more.`,
        `${n} refreshes its lobby often with new tables and seasonal events.`,
      ][(hash + 2) % 4],
    ],
    steps: [
      [`Tap the download button at the top of this page to get the ${n} APK.`, `Hit the gold Download APK button above to save ${n}.`, `Use the download button on this page - it fetches the ${n} APK directly.`, `Start with the big download button at the top to save the ${n} APK file.`][hash % 4],
      [`If Android blocks the ${n} file, allow installs from your browser in Settings, then go back.`, `Android may show an "unknown apps" prompt for ${n} - allow it for your browser once.`, `When Android asks about unknown sources for the ${n} APK, switch it on for your browser and return.`, `Grant the install permission if Android requests it for ${n}, then come back to the file.`][(hash + 1) % 4],
      [`Find the ${n} file in Downloads, open it and choose Install.`, `Open the ${n} APK from the notification bar or Downloads folder and tap Install.`, `Locate the downloaded ${n} file (about ${sizeMin} MB), tap it and confirm Install.`, `Tap the finished ${n} download and press Install - it takes under a minute.`][(hash + 2) % 4],
      [`Launch ${n} and sign up with your mobile number.`, `Open ${n}, choose Register and enter your mobile number.`, `Start ${n} and create an account with your phone number.`, `Run ${n} for the first time and register with your number.`][(hash + 3) % 4],
      [`Type in the OTP that ${n} sends by SMS to verify the number.`, `Enter the SMS OTP to confirm your number with ${n}.`, `Verify your ${n} account with the one-time code sent to your phone.`, `Confirm the OTP, then set a ${n} login password if asked.`][hash % 4],
      [`The ₹${b} ${n} signup bonus is added to your bonus balance straight after.`, `Your ₹${b} welcome bonus shows up in the wallet right away.`, `Collect the ₹${b} bonus from the gift or wallet tab and start playing.`, `₹${b} bonus balance is credited instantly - pick a table and play.`][(hash + 1) % 4],
    ],
    faqs: [
      {
        q: [`How much bonus does ${n} give on signup?`, `What is the ${n} signup bonus?`, `Do new ${n} users get a welcome bonus?`][hash % 3],
        a: [
          `New ${n} accounts get ₹${b} once the mobile number is verified with an OTP; it is ${n} bonus balance for playing, so only your winnings can be withdrawn.`,
          `${n} credits ₹${b} to every new account after OTP verification; the amount is play balance in ${n}, so winnings from it can be withdrawn but the bonus itself cannot.`,
          `Yes - ₹${b} is added as soon as you register on ${n}; treat the ${n} bonus as practice money, because you cash out what you win, not the bonus.`,
        ][(hash + 1) % 3],
      },
      {
        q: [`How do I add a bank account or UPI ID to ${n}?`, `Which payout methods does ${n} support?`, `Can I withdraw from ${n} to UPI?`][(hash + 1) % 3],
        a: [
          `Open the withdraw section in ${n} and add your bank account with the IFSC code, or your UPI ID - it must be in your own name, otherwise ${n} payouts can be held back.`,
          `${n} pays to UPI IDs and bank accounts - add either from the ${n} wallet screen, and make sure the name matches your registered details or the payout is held.`,
          `Yes - go to Wallet, then Withdraw in ${n}, add a UPI ID or bank account in your own name, and request from ₹${w} upwards.`,
        ][(hash + 2) % 3],
      },
      {
        q: [`What is the minimum withdrawal in ${n}?`, `How small can a ${n} withdrawal be?`, `Is there a withdrawal limit on ${n}?`][(hash + 2) % 3],
        a: [
          `The ${n} minimum withdrawal is ₹${w}; make one small ${n} withdrawal first and add more money only after it reaches you.`,
          `${n} lets you withdraw from ₹${w}, and a first ${n} test payout at that amount is the easiest way to check the app before depositing more.`,
          `You can request as little as ₹${w} from ${n}; daily caps vary with your ${n} VIP level, so check the wallet page for your limit.`,
        ][hash % 3],
      },
      {
        q: [`Who can play ${n}?`, `Is ${n} legal and who is it for?`, `What is the age limit for ${n}?`][hash % 3],
        a: [
          `${n} is meant for adults aged 18 and over, and since rules on real-money gaming in India have changed in recent years, check the current law where you live before you deposit in ${n}.`,
          `Only players aged 18+ should use ${n}, and because India's 2025 online gaming law restricts money games in several states, confirm what applies to you before opening ${n}.`,
          `${n} is an 18+ app, and because state rules on real-money play differ, read the law for your state before adding funds to ${n}.`,
        ][(hash + 1) % 3],
      },
      {
        q: [`Why isn't ${n} on Google Play?`, `Is the ${n} APK safe to install?`, `Where do I download ${n} from?`][(hash + 1) % 3],
        a: [
          `Real-money apps like ${n} are shared as APK files instead - download ${n} with the button on this page and allow "install unknown apps" for your browser when Android asks.`,
          `Google Play does not host real-money apps, so ${n} ships as an APK - use only the ${n} link on this page and skip modified versions shared in chats.`,
          `Download ${n} with the button at the top of this page - it points to the official ${n} APK, while files from Telegram forwards or random sites can carry trackers.`,
        ][(hash + 2) % 3],
      },
    ],
    },
    ...clean,
  };
};

export const popularSearches = [
  "Yono Games", "Yono Game", "All Yono Games", "All Yono Game", "Yono All Games", "Yono All Game",
  "Yono Rummy", "Yono Vip", "Yono Slots", "Yono 777", "Yono Arcade", "Yono Slots",
  "Rummy 91", "Spin Gold", "Ind Rummy", "Ind Bingo", "Ind Vip", "Jaiho Slots",
  "Jaiho 777", "Rummy 888", "Yono Games Apk", "All Yono App", "Spin Winner",
  "Game Rummy", "Spin 101", "Spin 777", "Rumble Rummy", "Rummy Ludo", "All Yono Apps", "All Yono Games App",
];

// Deterministic mock player count per game, e.g. "567.2K"
export const getPlayers = (slug) => {
  let hash = 0;
  for (let i = 0; i < slug.length; i++) hash = (hash * 31 + slug.charCodeAt(i)) % 997;
  const base = 100 + ((hash * 37) % 800);
  return `${base}.${hash % 10}K`;
};

export const DOWNLOAD_URL = "https://www.jeetspin17.com/?code=SYHD9HRVL45&t=1790781104";

export const TELEGRAM_LINK = "https://t.me/+u4jd9lJSP74zOWU1";

// Unique SEO meta per game - title pattern, description and keywords rotate by hash
export const getGameSeo = (game) => {
  let hash = 0;
  for (let i = 0; i < game.slug.length; i++) hash = (hash * 31 + game.slug.charCodeAt(i)) % 997;
  const n = game.name;
  const b = game.bonus;
  const w = game.minWithdraw;
  const kind = /rummy/i.test(n) ? "rummy" : /slot|spin|777|jackpot/i.test(n) ? "slots" : "casino";
  const titles = [
    `${n} (Yono) Download App & Get ₹${b} Bonus`,
    `${n} (Yono) Download App & Get ₹${b} Bonus Free`,
    `${n} – APK Download | Get Signup Bonus ₹${b} To ₹${b + 200} Free`,
    `${n} APK Download 2026 | ₹${b} Signup Bonus, ₹${w} Withdrawal`,
    `${n} Yono App Download – Claim ₹${b} Welcome Bonus Today`,
    `Download ${n} APK | New Yono ${kind === "rummy" ? "Rummy" : kind === "slots" ? "Slots" : "Games"} App With ₹${b} Bonus`,
  ];
  const descriptions = [
    `${n} Yono is an online gaming app where users play simple ${kind} games and explore bonus-based rewards. It offers an easy interface, quick signup with OTP, a ₹${b} welcome bonus and withdrawals from ₹${w} to UPI or bank.`,
    `Download the latest ${n} APK for Android. Sign up with your mobile number, collect ₹${b} signup bonus, play ${kind === "rummy" ? "13-card rummy and Teen Patti" : kind === "slots" ? "slots, spin wheels and jackpot rounds" : "rummy, slots and quick table games"} and withdraw from just ₹${w}.`,
    `${n} app review and download guide: ₹${b} free bonus on signup, ₹${w} minimum withdrawal, Android requirements, install steps and safety tips. Updated for 2026.`,
    `Looking for ${n} download link? Get the official ${n} Yono APK, claim ₹${b} welcome bonus, and read how deposits, withdrawals and daily rewards work before you install.`,
    `${n} is a Yono family ${kind} app with a ₹${b} joining bonus and fast UPI withdrawals starting at ₹${w}. See download steps, phone requirements and common questions here.`,
  ];
  const short = n.toLowerCase();
  const keywords = [
    short, `${short} apk`, `${short} download`, `${short} app`, `${short} yono`, `yono ${short}`,
    `${short} apk download`, `${short} signup bonus`, `${short} ₹${b} bonus`, `${short} withdrawal`,
    `${short} game`, `${short} real cash`, `${short} new version`, `${short} 2026`,
    kind === "rummy" ? "yono rummy apps" : kind === "slots" ? "yono slots apps" : "yono games apk",
    "maha games apps",
  ];
  const o = game.seo || {};
  return {
    title: o.title || titles[hash % titles.length],
    description: o.description || descriptions[(hash + 2) % descriptions.length],
    keywords: Array.isArray(o.keywords) && o.keywords.length ? o.keywords : (typeof o.keywords === "string" && o.keywords.trim() ? o.keywords.split(",").map((k) => k.trim()).filter(Boolean) : keywords),
    focus: n,
  };
};
